var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSkyPaymentsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 40,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M40 5H5v20h35V5zM22.5 22.5A7.49 7.49 0 0115 15c0-4.15 3.35-7.5 7.5-7.5S30 10.85 30 15s-3.35 7.5-7.5 7.5z",
    fill: "#006DFF",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 0H5C2.25 0 0 2.25 0 5v20c0 2.75 2.25 5 5 5h35c2.75 0 5-2.25 5-5V5c0-2.75-2.25-5-5-5zM5 25V5h35v20H5z",
    fill: "#006DFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5 7.5A7.49 7.49 0 0015 15c0 4.15 3.35 7.5 7.5 7.5S30 19.15 30 15s-3.35-7.5-7.5-7.5zM55 7.5V35c0 2.75-2.25 5-5 5H7.5v-5H50V7.5h5z",
    fill: "#006DFF"
  })));
}
export default SvgSkyPaymentsIcon;